<template>
  <div>
    <div class="innews max-w flex">
      <div class="left">
        <router-link to="/news" class="change">全部</router-link>
        <router-link to="/news/industry" class="change">行业资讯</router-link>
        <router-link to="/news/train" class="change">培训信息</router-link>
      </div>
      <div class="right">
        <router-link
          v-for="(item, index) in list"
          :key="'news' + index"
          :to="`/newsView/${item.id}`"
          class="news flex"
        >
          <p>{{ item.name }}</p>
          <span>{{ item.time.replace(/-/g, "/") }}</span>
        </router-link>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="page.total"
          :page-size="page.pageSize"
          :current-page="page.pageNum"
          @current-change="changePage"
          hide-on-single-page
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getList } from "@/api/web";
export default {
  data() {
    return {
      list: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  watch: {
    $route: {
      handler: function () {
        this.page.pageNum = 1;
        this.getInfo();
      },
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      getList(this.$route.meta.id, this.page).then((res) => {
        this.list = res.data.list;
        this.page.total = res.data.total;
      });
    },
    changePage(val) {
      this.page.pageNum = val;
      this.getInfo();
    },
  },
};
</script>

<style lang="scss" scoped>
.innews {
  margin: 30px auto;
  align-items: flex-start;
  .left {
    a {
      display: block;
      width: 220px;
      padding: 20px 0;
      border: 1px solid #e5e5e5;
      text-align: center;
      color: #333;
      position: relative;
      &:hover {
        border-color: #3d8aff;
      }
    }
    .router-link-exact-active {
      background: #cee2ff;
      color: #3d8aff;
      &::before {
        content: "";
        position: absolute;
        right: 0;
        background: #3d8aff;
        width: 5px;
        height: 44px;
        top: 5px;
        border-radius: 16px;
      }
      &:hover {
        border-color: #cee2ff;
      }
    }
  }
  .right {
    width: calc(100% - 280px);
    .news {
      font-size: 18px;
      color: #333333;
      padding: 20px 0 16px 20px;
      border-bottom: 1px solid #e5e5e5;
      position: relative;
      @media only screen and (min-width: 1200px) {
        &:first-child {
          padding-top: 0;
          &::after {
            top: 4px;
          }
        }
      }

      p {
        width: 100%;
        padding-right: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        color: #999999;
      }

      &::after {
        position: absolute;
        content: "";
        width: 8px;
        height: 8px;
        border: 1px solid #c4c4c4;
        border-radius: 100%;
        left: 0;
        top: 24px;
      }
      &:hover {
        color: #3d8aff;
        &::after {
          border-color: #3d8aff;
        }
      }
    }
    .el-pagination {
      text-align: right;
      margin-top: 20px;
    }
  }
  @media only screen and (max-width: 1200px) {
    flex-wrap: wrap;
    .left,
    .right {
      width: 100%;
    }
    .left {
      display: flex;
      width: 80%;
      margin: 0 auto;
      a {
        flex-grow: 1;
        &::before {
          opacity: 0;
        }
      }
    }
    .right {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      .news {
        flex-wrap: wrap;
        p,
        span {
          width: 100%;
        }
        p {
          padding: 0;
          white-space: normal;
          line-height: 1.5;
        }
        span {
          margin-top: 3px;
        }
        &::after {
          top: 28px;
        }
      }
    }
  }
}
</style>
